module.exports = __webpack_public_path__ + "img/progress_bg.c4fdee80.png";